import type { Theme, ThemeOptions } from '@mui/material/styles';

const sizeMap = {
  small: 14,
  medium: 20,
  large: 24
} as const;

export function iconThemeComponents(_theme: Theme): ThemeOptions['components'] {
  return {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          '&.SmIcon-size-small': {
            fontSize: sizeMap.small,
            width: sizeMap.small,
            height: sizeMap.small
          },
          '&.SmIcon-size-medium': {
            fontSize: sizeMap.medium,
            width: sizeMap.medium,
            height: sizeMap.medium
          },
          '&.SmIcon-size-large': {
            fontSize: sizeMap.large,
            width: sizeMap.large,
            height: sizeMap.large
          }
        }
      }
    }
  };
}
